import Base from '../../components/base';

const PERIOD_BUTTON_REF = 'period';

const TIMEFRAMES = {
	intraday: 'intraday',
	day: 'day',
	month: 'month',
	YTD: 'YTD',
	year: 'year',
	all: 'all',
};

const EVENTS = {
	periodChange: 'periodChange',
};

class PeriodSelector extends Base {
	constructor(el, period = 'day', multiplier = '1') {
		super(el);

		this.buttons = this.queryAll(`[data-ref="${PERIOD_BUTTON_REF}"]`);

		// Event listeners
		this.on('click');
	}

	get activeButton() {
		return this.buttons.find(b => b.classList.contains('is-active'));
	}

	get activePeriod() {
		const {
			dataset:
			{
				period,
				multiplier,
			},
		} = this.activeButton;

		return {
			multiplier,
			period,
		};
	}

	onClick(e) {
		const { target,
			target: {
				dataset: {
					ref,
				},
			} } = e;

		if (ref !== PERIOD_BUTTON_REF || this.activeButton === target) {
			return;
		}

		this.selectPeriod(target);
	}

	preSelect(period, multiplier) {
		const button = this.buttons.find(b => b.dataset.period === period &&
			b.dataset.multiplier === `${multiplier}`);

		if (button) {
			this.updateButtonStates(button);
		}
	}

	selectPeriod(button) {
		this.updateButtonStates(button);
		this.dispatchPeriodChangeEvent();
	}

	dispatchPeriodChangeEvent() {
		const { period } = this.activePeriod;

		const event = new CustomEvent(EVENTS.periodChange, {
			bubbles: true,
			detail: {
				period,
			},
		});

		this.el.dispatchEvent(event);
	}

	updateButtonStates(activeButton) {
		const currentActive = this.activeButton;

		if (currentActive) {
			currentActive.classList.remove('is-active');
		}

		activeButton.classList.add('is-active');
	}
}

export default PeriodSelector;

export {
	TIMEFRAMES,
	EVENTS,
};

